import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {  formatDateTime } from "../formateDate";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function FilePropertiesDialog({item}) {
  const [open, setOpen] = React.useState(false);
  
  

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Typography onClick={handleClickOpen}>Properties</Typography>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Properties
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography  sx={{display: 'flex', mb:3}}>
           <strong style={{minWidth: 90}}>Name: </strong> { item?.original_filename || item?.name }
          </Typography>
          <Typography  sx={{display: 'flex', mb:3}}>
             <strong style={{minWidth: 90}}>Size: </strong> {item?.size}
          </Typography>
          <Typography  sx={{display: 'flex', mb:3}}>
             <strong style={{minWidth: 90}}>Extention: </strong> {item?.ext}
          </Typography>
          <Typography  sx={{display: 'flex', mb:3}}>
            <strong style={{minWidth: 90}}>Created at: </strong>  {formatDateTime(item?.created_date)}

          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="outlined" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>
      
    </React.Fragment>
  );
}
